export default {"src":"/_next/static/media/Osteoporosis-relatedSpineConditions.cbe8b1db.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};